import { render, staticRenderFns } from "./SharedMediaInfo.vue?vue&type=template&id=e4a0e27a&"
import script from "./SharedMediaInfo.vue?vue&type=script&lang=js&"
export * from "./SharedMediaInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports